import {FC, RefObject} from 'react';
import {Box} from '@chakra-ui/react';

import {TMemoryView} from '../../MemoryScene';

import {MemoryList} from './components';

interface IProps {
  ref: RefObject<HTMLDivElement | null>;
  currentView: TMemoryView;
}

export const Memories: FC<IProps> = ({ref, currentView}) => {
  const isList = currentView === 'memory_list';

  return (
    <Box ref={ref} h={'calc(100% - 24px)'} overflow={'hidden'}>
      {isList && <MemoryList containerRef={ref} />}
    </Box>
  );
};
